import { PreSignedUrlBatchResponse, ProjectElementListResponse, ProjectElementResponse, SimpleStringResponse } from '../dto/ResDtoRepository';
import { CreateProjectElementReq, DeleteProjectElementReq, PreSignedUrlProjectElementBatchReq, UpdatePEBulkReq, UpdateProjectElementBulkInfoReq, UpdateProjectElementReq, UpdateReorderListReq, DeleteTextBlockInPEReq, CreateProjectElementTextBlockWithTextBlockReq, CreateProjectElementWithTextReq, ImportWorkOrDetailAsPeBulkReq } from '../dto/ReqDtoRepository';
import { sendApiRequest, sendDeleteApiRequest, sendGetApiRequest } from './apiConfig';


export const getProjectElementList = async (aui: string, projectId: string): Promise<ProjectElementListResponse> => {
  return sendGetApiRequest<ProjectElementListResponse>(`/api/v1/project-element?aui=${aui}&projectId=${projectId}`);
};

export const createProjectElement = async (aui: string, data: CreateProjectElementReq): Promise<ProjectElementResponse> => {
  return sendApiRequest<ProjectElementResponse>('post', `/api/v1/project-element?aui=${aui}`, data);
};

export const createProjectElementBulk = async (aui: string, data: PreSignedUrlProjectElementBatchReq): Promise<PreSignedUrlBatchResponse> => {
  return sendApiRequest<PreSignedUrlBatchResponse>('post', `/api/v1/project-element/bulk?aui=${aui}`, data);
};

export const updateProjectElement = async (aui: string, data: UpdateProjectElementReq): Promise<ProjectElementResponse> => {
  return sendApiRequest<ProjectElementResponse>('put', `/api/v1/project-element?aui=${aui}`, data);
};

export const updatePEBulk = async (aui: string, data: UpdatePEBulkReq): Promise<ProjectElementListResponse> => {
  return sendApiRequest<ProjectElementListResponse>('put', `/api/v1/project-element/bulk?aui=${aui}`, data);
};

export const updateProjectElementBulkInfo = async (aui: string, data: UpdateProjectElementBulkInfoReq): Promise<ProjectElementListResponse> => {
  return sendApiRequest<ProjectElementListResponse>('put', `/api/v1/project-element/bulk-info?aui=${aui}`, data);
};

export const deleteProjectElement = async (aui: string, data: DeleteProjectElementReq): Promise<SimpleStringResponse> => {
  return sendDeleteApiRequest<SimpleStringResponse>(`/api/v1/project-element?aui=${aui}&peId=${data.projectElementId}`);
};

export const deleteTextBlockInPE = async (aui: string, data: DeleteTextBlockInPEReq): Promise<SimpleStringResponse> => {
  return sendDeleteApiRequest<SimpleStringResponse>(`/api/v1/project-element/text-block?aui=${aui}&peId=${data.projectElementId}&textBlockId=${data.textBlockId}`);
};

export const importWorkOrDetailAsPeBulk = async (aui: string, data: ImportWorkOrDetailAsPeBulkReq): Promise<ProjectElementListResponse> => {
  return sendApiRequest<ProjectElementListResponse>('post', `/api/v1/project-element/import?aui=${aui}`, data);
};

export const createProjectElementWithText = async (aui: string, data: CreateProjectElementWithTextReq): Promise<ProjectElementResponse> => {
  return sendApiRequest<ProjectElementResponse>('post', `/api/v1/project-element/import/text?aui=${aui}`, data);
};

export const addTextBlockInProjectElement = async (aui: string, data: CreateProjectElementTextBlockWithTextBlockReq): Promise<ProjectElementResponse> => {
  return sendApiRequest<ProjectElementResponse>('post', `/api/v1/project-element/import/text-block?aui=${aui}`, data);
};

export const reorderProjectElement = async (aui: string, data: UpdateReorderListReq): Promise<ProjectElementListResponse> => {
  return sendApiRequest<ProjectElementListResponse>('put', `/api/v1/project-element/reorder?aui=${aui}`, data);
};
